let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("bmCqg")).then(() => parcelRequire('7F6VS'));